import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { LoaderService } from 'app/shared/services/loader.service';
import { ModalService } from 'app/shared/services/modal.service';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { GlobalConfiguration } from '../../user-dashboard/shared/global-configuration.model';
import { GlobalConfigurationService } from '../../user-dashboard/shared/global-configuration.service';

@Component({
  selector: 'app-global-configuration',
  templateUrl: './global-configuration.component.html',
  styleUrls: ['./global-configuration.component.scss']
})
export class GlobalConfigurationComponent {

  globalConfigurations: GlobalConfiguration[]     = [];
  pageGlobalConfigurations: GlobalConfiguration[] = [];
  editButtonDisplay: boolean;
  saveButtonDisplay: boolean;
  deleteButtonDisplay: boolean;
  currentConfiguration: string;

  constructor(
    private globalConfigurationService: GlobalConfigurationService,
    private loader: LoaderService,
    private toastr: ToastrService,
    private modalService: ModalService
  ) {
    this.loader.startLoad(false);
    this.globalConfigurationService.getAll()
      .pipe(finalize(() => this.loader.stopLoad()))
      .subscribe((globalConfigurations: GlobalConfiguration[]) => this.globalConfigurations = globalConfigurations);
    this.initializeButtonsDisplay();
  }

  createNewSupportMail() {
    this.globalConfigurations.push(GlobalConfiguration.fromDto({ id: null, serviceEmail: null }));
    this.updateServiceEmail(null);
  }

  updateServiceEmail(id: string) {
    this.deleteButtonDisplay  = true;
    this.saveButtonDisplay    = true;
    this.editButtonDisplay    = false;
    this.currentConfiguration = id;
  }

  saveServiceEmail(globalConfiguration: GlobalConfiguration) {
    this.loader.startLoad();
    if (globalConfiguration.id) {
      this.globalConfigurationService.update(globalConfiguration)
        .pipe(finalize(() => {
          this.loader.stopLoad();
        }))
        .subscribe(() => {
          this.initializeButtonsDisplay();
          this.toastr.success('Global Configuration successfully updated', 'Success');
        }, (error: HttpErrorResponse) => {
          console.log(error);
          this.toastr.error(error.error.message || 'Error while updating the global configuration', 'Error');
        });
    } else {
      this.globalConfigurationService.create(globalConfiguration)
        .pipe(finalize(() => {
          this.loader.stopLoad();
        }))
        .subscribe((gc) => {
          this.initializeButtonsDisplay();
          this.globalConfigurations.forEach(a => {
            if (!a.id) {
              a.id = gc.id
            }
          });

          this.toastr.success('Global Configuration successfully created', 'Success');
        }, (error: HttpErrorResponse) => {
          console.log(error);
          this.toastr.error(error.error.message || 'Error while creating the global configuration', 'Error');
        });
    }
  }

  deleteServiceEmail(content, id: string) {
    this.modalService.open({
      title: 'Delete Global Configuration',
      content,
      closeButton: {
        text: 'No, Keep it'
      },
      validateButton: {
        type: 'danger',
        text: 'Yes, Delete it',
        icon: 'fa fa-trash'
      }
    }).subscribe(() => this.doDeleteServiceEmail(id));
  }

  doDeleteServiceEmail(id: string) {
    if (!id) {
      const index = this.globalConfigurations.findIndex(gc => !gc.id);
      if (index >= 0) {
        this.globalConfigurations.splice(index, 1);
      }
      return;
    }

    this.loader.startLoad();
    this.globalConfigurationService.delete(id)
      .pipe(finalize(() => {
        this.loader.stopLoad();
      }))
      .subscribe(() => {
        this.initializeButtonsDisplay();
        const index = this.globalConfigurations.findIndex(gc => gc.id === id);
        if (index >= 0) {
          this.globalConfigurations.splice(index, 1);
        }
        this.toastr.success('Global Configuration successfully deleted', 'Success');
      }, (error: HttpErrorResponse) => {
        console.log(error);
        this.toastr.error(error.error.message || 'Error while deleting the global configuration', 'Error');
      });
  }

  initializeButtonsDisplay() {
    this.deleteButtonDisplay  = false;
    this.saveButtonDisplay    = false;
    this.editButtonDisplay    = true;
    this.currentConfiguration = '';
  }

}
